export const $ = document.querySelector.bind(document)
export const $$ = document.querySelectorAll.bind(document)



// WEBPACK FOOTER //
// ./srp/scripts/utils/dom.js